export enum CashTransferTabs {
  InternalCashTransfer = 'InternalCashTransfer',
  HistoryCashInternal = 'HistoryCashInternal',
  BankCashTransfer = 'BankCashTransfer',
  HistoryCashBank = 'HistoryCashBank',
  DepositToVSD= 'DepositToVSD',
  HistoryDepositToVSD= 'HistoryDepositToVSD',
  WithdrawFromVSD= 'WithdrawFromVSD',
  HistoryWithdrawFromVSD= 'HistoryWithdrawFromVSD',
}



// WEBPACK FOOTER //
// ./src/components/areas/Account/CashTransfer1/enum.ts